module.exports = __webpack_public_path__ + "static/genesis-buy-click-86c6822c5fa2207208db40b9dd98037a.mp3";